import { render } from "./CreateBatchDialog.vue?vue&type=template&id=697549b6"
import script from "./CreateBatchDialog.vue?vue&type=script&lang=js"
export * from "./CreateBatchDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__